import { inject } from '@angular/core';

import { homePageGuard } from '@frontend/vanilla/features/home-page';

import { HomePageConfig } from '../client-config/client-config.models';
import { CommonMethodsService } from '../tracking/common-methods-service';

export const PortalHomePageGuard = async () => {
    const config = inject(HomePageConfig);
    const commonService = inject(CommonMethodsService);

    if (!config.isConfigReady) await commonService.loadClientConfig([HomePageConfig]);
    if (config.isVanillaHomePageEnabled) {
        return homePageGuard();
    } else {
        return true;
    }
};
